import imported_asset_individualMessage_tsx_0 from '../../../assets/Icons/valid.svg';
import imported_asset_individualMessage_tsx_1 from '../../../assets/Icons/invalid.svg';
import imported_asset_individualMessage_tsx_2 from '../../../assets/Icons/rule.svg';
import {Validation} from "../models/types";
import Image from '../../modules/image';
import Text from '../../modules/text';

type IndividualMessageProps = {
    rules?: Array<Validation>
}

const IndividualMessage = (props: IndividualMessageProps) => {
    const individualMessage = props.rules?.filter(x => x.text);

    if (individualMessage) {
        return (
            <div className="validations">
                {individualMessage.map((item, index) => (
                    <div key={"validation-item-" + index}
                         className={"validation" + (item.isValid ? " valid" : item.isValid === false ? " invalid" : "")}>
                        {item.isValid === true &&
                            <Image src={imported_asset_individualMessage_tsx_0}></Image>
                        }
                        {item.isValid === false &&
                            <Image src={imported_asset_individualMessage_tsx_1}></Image>
                        }
                        {item.isValid === undefined &&
                            <Image src={imported_asset_individualMessage_tsx_2}></Image>
                        }
                        <Text size={4}>
                            {item.text}
                        </Text>
                    </div>
                ))}
            </div>
        )
    }

    return (null);
}

export default IndividualMessage;